import type { AnnotationCommandData } from '@festina/legalentity-general-types/legalentity'
import type { ExcludeString } from '@festina-life/core'

import { LegalEntityAnnotationCommand } from '../../../areas/annotation/LegalEntityAnnotationCommand'
import type { CommandDataRecord } from '../types'

export const annotationCommands: CommandDataRecord<
  ExcludeString<AnnotationCommandData['_type']>
> = {
  AnnotationCommandData: LegalEntityAnnotationCommand,
}
